document.addEventListener('alpine:init', () => {
    Alpine.data('productComponent', (initialData) => ({
        ...initialData,
        scrolled: false,
        loading: false,
        quantity: 1,
        stickyBarClosed: false,
        formatMoney(val) {
            if (typeof val !== 'number') return val;
            return this.moneyFormat.replace('[price]', val.toFixed(2));
        },
        programmatic: false,
        scrollToImage(url) {
            if (this.programmatic) return;
            const index = this.productImages.indexOf(url);
            if (index !== -1 && this.$refs.slider) {
                this.programmatic = true;
                this.$refs.slider.scrollTo({
                    left: index * this.$refs.slider.offsetWidth,
                    behavior: 'smooth'
                });
                setTimeout(() => { this.programmatic = false; }, 600);
            }
        },
        scrollToThumb(url) {
            const index = this.productImages.indexOf(url);
            if (index !== -1 && this.$refs.thumbnails) {
                const container = this.$refs.thumbnails;
                const thumb = container.children[index];
                if (thumb) {
                    const containerWidth = container.offsetWidth;
                    const thumbOffset = thumb.offsetLeft;
                    const thumbWidth = thumb.offsetWidth;
                    const scrollLeft = thumbOffset - (containerWidth / 2) + (thumbWidth / 2);
                    container.scrollTo({
                        left: scrollLeft,
                        behavior: 'smooth'
                    });
                }
            }
        },
        handleScroll(e) {
            if (this.programmatic) return;
            const slider = e.target;
            const index = Math.round(slider.scrollLeft / (slider.offsetWidth || 1));
            if (this.productImages[index] && this.currentImage !== this.productImages[index]) {
                this.currentImage = this.productImages[index];
            }
        },
        initGallery() {
            this.$watch('currentImage', (val) => {
                this.scrollToImage(val);
                this.scrollToThumb(val);
            });
        },
        scrollToGallery() {
            if (window.innerWidth < 768) {
                const gallery = document.querySelector('.product-slider') || document.querySelector('.sticky-top');
                if (gallery) {
                    gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        },
        updateVariant() {
            let variant = this.allVariants.find(v => {
                return v.options.length === this.options.length &&
                       v.options.every((opt, i) => opt === this.options[i]);
            });
            if (variant) {
                this.selectedVariant = variant.id;
                this.price = variant.price;
                this.comparePrice = variant.comparePrice;
                this.available = variant.available;
                if (variant.featured_image) {
                    this.currentImage = variant.featured_image;
                    this.scrollToGallery();
                }
            }
        },
        updateBundleQty(qty, bundleValue) {
            if (this.bundleIndex !== undefined && this.bundleIndex > -1) {
                this.options[this.bundleIndex] = bundleValue;
            }
            this.bundleQty = qty;
            while (this.selectedColors.length < qty) {
                this.selectedColors.push(this.selectedColors[0] || '');
            }
            if (this.selectedColors.length > qty) {
                this.selectedColors.length = qty;
            }
            this.updateVariant();
        },
        getCartPayload() {
            let items = [];
            let singleBundleValue = null;
            if (this.bundleIndex !== undefined && this.bundleIndex > -1) {
                let lowestQty = Infinity;
                this.allVariants.forEach(v => {
                    let q = parseInt(v.options[this.bundleIndex]);
                    if (!isNaN(q) && q < lowestQty) {
                        lowestQty = q;
                        singleBundleValue = v.options[this.bundleIndex];
                    }
                });
            }

            if (this.bundleQty > 1 && this.colorIndex > -1 && singleBundleValue) {
                this.selectedColors.forEach(color => {
                    let tempOptions = [...this.options];
                    tempOptions[this.bundleIndex] = singleBundleValue;
                    tempOptions[this.colorIndex] = color;
                    
                    let singleVariant = this.allVariants.find(v => {
                        return v.options.length === tempOptions.length &&
                               v.options.every((opt, i) => opt === tempOptions[i]);
                    });
                    
                    if (singleVariant) {
                        let existing = items.find(i => i.id === singleVariant.id);
                        if (existing) {
                            existing.quantity += this.quantity;
                        } else {
                            items.push({ id: singleVariant.id, quantity: this.quantity });
                        }
                    }
                });
            } else {
                items.push({ id: this.selectedVariant, quantity: this.quantity });
            }

            if (items.length === 0) return null;
            return { items: items };
        },
        updateColor(idx, value) {
            this.selectedColors[idx] = value;
            if (idx === 0 && this.colorIndex > -1) {
                this.options[this.colorIndex] = value;
                this.updateVariant();
            }
        },
        updateFromId(id) {
            let variant = this.allVariants.find(v => v.id == id);
            if (variant) {
                this.selectedVariant = variant.id;
                this.price = variant.price;
                this.comparePrice = variant.comparePrice;
                this.options = [...variant.options];
                this.available = variant.available;
                if (variant.featured_image) {
                    this.currentImage = variant.featured_image;
                    this.scrollToGallery();
                }
                
                if (this.bundleIndex !== undefined && this.bundleIndex > -1) {
                    this.bundleQty = parseInt(variant.options[this.bundleIndex]) || 1;
                }
                if (this.colorIndex !== undefined && this.colorIndex > -1) {
                    this.selectedColors[0] = variant.options[this.colorIndex];
                }
                while (this.selectedColors.length < this.bundleQty) {
                    this.selectedColors.push(this.selectedColors[0] || '');
                }
                if (this.selectedColors.length > this.bundleQty) {
                    this.selectedColors.length = this.bundleQty;
                }
            }
        },
        isOptionValueAvailable(optionIndex, value) {
            let tempOptions = [...this.options];
            tempOptions[optionIndex] = value;
            let variant = this.allVariants.find(v => {
                return v.options.length === tempOptions.length &&
                       v.options.every((opt, i) => opt === tempOptions[i]);
            });
            return variant ? variant.available : false;
        }
    }));
});
